import React from "react";
import { Footer } from "./Footer/Footer";
import Header from "./Header/Header";
import { Main } from "./Main/Main";
import CssBaseline from "@mui/material/CssBaseline";
const App = () => {
  return (
    <>
      <CssBaseline />
      <Header />
      <Main />
      <Footer />
    </>
  );
};

export default App;
